
import firebase from '../fb'
import db from '../db'
import { firestoreAction } from 'vuexfire'


const state = {
  btc_deposit: [],
  cfa_deposit: [],
  pm_deposit: [],
  history : [],
  coinpaymentAdr:[],
  btcAddress:[],
  btcAddress0:[],
  addresses:[],
  index:[]
};

const getters = {
  cfa_deposit: state => {
    var user = firebase.auth().currentUser;
    return state.cfa_deposit.filter(obj => obj.user_id === user.uid)
  },
  btc_deposit: state => {
    var user = firebase.auth().currentUser;
    return state.btc_deposit.filter(obj => obj.user_id === user.uid)
  },
  pm_deposit: state => {
    var user = firebase.auth().currentUser;
    return state.pm_deposit.filter(obj => obj.user_id === user.uid)
  },

  history: state => {
    return state.history
  },

  btcObj: state => {
    var user = firebase.auth().currentUser;
     var obj=state.coinpaymentAdr.find(obj => obj.user_id == user.uid)
     return obj
  },

  address: state => {
    var user = firebase.auth().currentUser;
     var obj=state.addresses
     return obj
  },
  
  coinpayment_btcAdr: state => {
    var user = firebase.auth().currentUser;
     var obj=state.coinpaymentAdr.find(obj => obj.user_id == user.uid)
     return obj.btcAdr
  },
 
  btcAddress: state => {
    var user = firebase.auth().currentUser;
     var obj=state.btcAddress.find(obj => obj.user_id == user.uid)
     return  obj ? obj.btcAdr :  0
  },

  btcAddress0: state => {
    var user = firebase.auth().currentUser;
     var obj=state.btcAddress0.find(obj => obj.user_id == user.uid)
    return  obj ? obj.btcAdr :  0
  },
  index:state => {
    return state.index.index2
  },
  
};

const mutations = {
  
  async cfa_deposit(state, payload) {
    let user = await firebase.auth().currentUser;
    let result = await db.collection("transactions").doc("cfa").collection('cfa_deposit').doc()
    let cfaW = {
      id: result.id,
      user_id: user.uid,
      amount: payload.amount,
      moyen: payload.moyen,
      txid: payload.txid,
      status: 'attente',
      created_at: firebase.firestore.FieldValue.serverTimestamp()
    }
    console.log(cfaW);
    
    if (payload.moyen=='Ecobank'){
      result.set(cfaW).then(()=>{
        swal("Success!", "Dépot CFA réussi!", "success", {
          button: "ok"
        })

        window.location.reload()
      }).catch((err) => {
        console.log(err);
        swal("Erreur!!!", "quelque chose n'a pas marché!", "error", {
          button: "ok"
        })
      })
    }else{
      var adress= db.collection("transactions").doc("cfa").collection('cfa_deposit').where("txid", "==",payload.txid).get()
    adress.then(function(querySnapshot) {
      if (querySnapshot.empty==true) {
        result.set(cfaW).then(()=>{
          swal("Success!", "Dépot CFA réussi!", "success", {
            button: "ok"
          })
          window.location.reload()
        }).catch((err) => {
          console.log(err);
          swal("Erreur!!!", "quelque chose n'a pas marché!", "error", {
            button: "ok"
          })
          window.location.reload()
        })
      }else{
        swal("Erreur!!!", "TxID déjà enrégistré!", "error", {
          button: "ok"
        })
        window.location.reload()
      }
  })
    }
  },

  async btc_deposit(state, payload) {
    var user = await firebase.auth().currentUser;
    var result = await db.collection("transactions").doc("btc").collection("btc_deposit").doc()

    let am = Number(payload.amount);
          let deposit_fee = 0

          if (am >= 0.0005) {
            switch (true) {
              
              
              case ( 0.0005 <= am && am < 0.0011 ): deposit_fee = 0.00005
                break;

              case ( 0.0011 <= am && am < 0.005 ): deposit_fee = 0.0001
                break;

                case ( 0.005 <= am && am < 0.01 ): deposit_fee = 0.00015
                break;
      
                case ( 0.01 <= am && am < 0.02 ): deposit_fee = 0.0002
                break;

                case ( 0.02 <= am && am < 0.03 ): deposit_fee = 0.0003
                break;
      
              case ( 0.03 <= am && am < 0.04 ): deposit_fee = 0.00035
                break;

              case ( 0.04 <= am && am < 0.05 ): deposit_fee = 0.0004
                break;
      
              case ( 0.05 <= am && am < 0.1 ): deposit_fee = 0.0005
                break;
  
              case ( 0.1 <= am ): deposit_fee = 0.001
                break;

              default: deposit_fee=0
                break;
            }

            am = am - deposit_fee
          }

    var btcW = {
      id: result.id,
      user_id: user.uid,
      amount: am,
      hash: payload.hash,
      status: 'complete',
      created_at: firebase.firestore.FieldValue.serverTimestamp()
    }

    let get_hash = db.collection("transactions").doc("btc").collection("btc_deposit").where("hash", "==",payload.hash).get()

    get_hash.then(async querySnapshot=>{
      console.log(querySnapshot.empty);
      
      try {
        await db.runTransaction(async (tx) => {

        const validateDeposit = ()=>{
          const add_deposit_fee=(fee)=>{
            const increment = firebase.firestore.FieldValue.increment(fee);
            const storyRef = db.collection('perso').doc('sq0uDLaLRWWmdJd3srxk');
            tx.update(storyRef,{ btc_deposit_fee: increment });
          }

          tx.set(result,btcW)
          const increase = firebase.firestore.FieldValue.increment(am);
          const userRef = db.collection('users').doc(user.uid)
          tx.update(userRef, { btcBalance: increase })

          if (deposit_fee > 0) {
            add_deposit_fee(deposit_fee)
          }

          swal("Success!", `${payload.amount} BTC déposé avec success `, "success", {
            button: "ok"
          })
          
        }

        if (querySnapshot.empty==true) {
          validateDeposit()
        }else{
          
          let usersWithHash= []
          
            await querySnapshot.forEach( (doc)=>{
              // doc.data() is never undefined for query doc snapshots
              console.log(doc.id, " => ", doc.data());
              usersWithHash.push(doc.data().user_id)
            });

          if (usersWithHash.indexOf(user.uid) === -1 ) {
            validateDeposit()
          }else{
            swal("Erreur!!!", "Transaction déja enrégistrée avec ce hash!", "error", {
            button: "ok"
          })
          return

          }
        }
      });

      console.log('Transaction success!');
     
      setTimeout(() => {
        window.location.reload()
      }, 3000);
    
    } catch (e) {
      console.log('Transaction failure:', e);

      setTimeout(() => {
        window.location.reload()
      }, 3000);
    }

    })

  },

  async test(state, payload){
    var user = await firebase.auth().currentUser;
    var result = await db.collection("transactions").doc("cfa").collection("cfa_deposit").doc()
    let x = {
      id: result.id,
      amount: Number(payload.amount),
      batch: '',
      user_id: user.uid,
      payer: '',
      v2_hash: '',
      status: ''
    };
    result.set(x).then(()=> {
      console.log('sucess');
      
    })
  } ,
  async btcAdrGenerate(state, payload) {

    var user = await firebase.auth().currentUser;
    var result =  db.collection("btcAddress2").doc()
    let index_ref = db.collection('index').doc('btcIndex')
    var adr = {
      id: result.id,
      user_id: user.uid,
      btcAdr: payload.btcAdr,
      index2: payload.index,
      created_at: firebase.firestore.FieldValue.serverTimestamp()
    }

    try {
      await db.runTransaction(async (tx) => {
        tx.set(result,adr)
        tx.update(index_ref, { index2: payload.index })

      });
    
      console.log('Transaction success!');
    } catch (e) {
      console.log('Transaction failure:', e);
    }
    
  },
  

};

const actions = {
  
  bind_cfa_deposit: firestoreAction(context => {
    let user = firebase.auth().currentUser;
    return context.bindFirestoreRef('cfa_deposit', db.collection('transactions').doc('cfa').collection('cfa_deposit').where("user_id", "==", user.uid).orderBy('created_at', 'desc').limit(10));
  }),
  bind_btc_deposit: firestoreAction(context => {
    let user = firebase.auth().currentUser;
    return context.bindFirestoreRef('btc_deposit', db.collection('transactions').doc('btc').collection('btc_deposit').where("user_id", "==", user.uid).orderBy('created_at', 'desc').limit(10));
  }),
  bind_pm_deposit: firestoreAction(context => {
    let user = firebase.auth().currentUser;
    return context.bindFirestoreRef('pm_deposit', db.collection('transactions').doc('pm').collection('pm_deposit').where("user_id", "==", user.uid).orderBy('created_at', 'desc').limit(10));
  }),

  bind_history: firestoreAction(context => {
    let user = firebase.auth().currentUser;
    return context.bindFirestoreRef('history', db.collection('history').where("user_id", "==", user.uid).where("type", "==", 'deposit').orderBy('created_at', 'desc').limit(10));
  }),

  bindCoinpaymentBtc: firestoreAction(context => {
    var user = firebase.auth().currentUser;
    console.log(user.uid);
    return context.bindFirestoreRef('coinpaymentAdr', db.collection('btcAddressCoinpayment').where("user_id", "==", user.uid));
  }),

  bind_addresses: firestoreAction(context => {
    console.log('bind_address');
    var user = firebase.auth().currentUser;
    let user_id = user.uid;
    return context.bindFirestoreRef('addresses', db.collection('addresses').doc(user_id));
  }),

  bindIndex: firestoreAction(context => {
    return context.bindFirestoreRef('index', db.collection('index').doc('btcIndex'));
  }),

  depotCfa({ commit }, payload) {
    commit('cfa_deposit', payload)
  },
  depotBtc({ commit }, payload) {
    commit('btc_deposit', payload)
  },
  generate({ commit }, payload) {
    commit('btcAdrGenerate', payload)
  },
  test({ commit }, payload) {
    commit('test', payload)
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}